// extracted by mini-css-extract-plugin
export default {"container":"Commissions_container__+Ccw8","slider":"Commissions_slider__omq-4","slide":"Commissions_slide__I4UG-","pricingTable":"Commissions_pricingTable__Dyv4z"};